// extracted by mini-css-extract-plugin
module.exports = {"Image":"Certificate_Image__1tZy7","Video":"Certificate_Video__2Bnad","Certificates":"Certificate_Certificates__26BmL","YTVideo":"Certificate_YTVideo__loGVX"};